const state = {
    items: null,
    collection: null
}
const mutations = {
    'SET_COLLECTION' (state, data) {
		state.collection = data
    },
    'SET_ITEMS' (state, data) {
		state.items = data
    }
}
const actions = {
    async fetchCurrencies ({commit, dispatch}) {
		await dispatch('callApi', {
			method: 'GET',
			ignoreBaseUrl: true,
			url: `/currencies`
		}).then((res) => {
			commit('SET_COLLECTION', res.data)
			commit('SET_ITEMS', res.data._embedded.currencies.filter(i => i.Status == '1'))
		}).catch((err) => {
			commit('SET_ITEMS', [])
			console.log(err)
		})
    }
}
const getters = {
    getItems: (state) => {
        return state.items
    },
    getCollection: (state) => {
        return state.collection
    }
}

export default {
	state,
	mutations,
	actions,
	getters
}
